import { render, staticRenderFns } from "./HangulWordWrapText.vue?vue&type=template&id=0ffa32b8&scoped=true"
import script from "./HangulWordWrapText.vue?vue&type=script&lang=js"
export * from "./HangulWordWrapText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa32b8",
  null
  
)

export default component.exports